const internalSlotMap = new WeakMap();
export default function getInternalSlots(x) {
    let internalSlots = internalSlotMap.get(x);
    if (!internalSlots) {
        internalSlots = Object.create(null);
        internalSlotMap.set(x, internalSlots);
    }
    return internalSlots;
}
//# sourceMappingURL=get_internal_slots.js.map